var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"policy-heading"},[_vm._v("Terms and Conditions")]),_c('p',{staticClass:"policy-date"},[_vm._v("Last updated: March 23, 2022")]),_c('p',{staticClass:"policy-description"},[_vm._v(" Please read these terms and conditions carefully before using Our Service. ")])])
}]

export { render, staticRenderFns }